import React from "react";

/** Generic policy section shell: anchored heading with an icon + content. */
function Section({ id, icon, title, children }) {
  return (
    <section id={id}>
      <h2><span className="icon">{icon}</span> {title}</h2>
      {children}
    </section>
  );
}

export default Section;
